module.exports = __webpack_public_path__ + "img/icon-18.8df9c8d0.png";